import React, { useEffect, useState } from 'react';
import Wrapper from '../../../components/Wrapper';
import SampleTable from './SampleTable';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../utils/axios';

const FieldOfficerSamples = () => {
  const [samples, setSamples] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    const fetchSamples = async () => {
      try {
        const { data } = await axiosInstance.get(`/field-officer/samples/${id}`);
        setSamples([...data]);
      } catch (err) {
        console.log('ERROR: ', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSamples();
  }, [id]);

  return (
    <Wrapper>
      <h1>Samples</h1>
      {isLoading ? (
        <div className="text-center py-4">Loading samples...</div>
      ) : (
        <SampleTable data={samples} />
      )}
    </Wrapper>
  );
};

export default FieldOfficerSamples;